if (!customElements.get('vbb-reactive-price')) {
  customElements.define('vbb-reactive-price', class ReactivePrice extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    handleVariantChange() {
      this.innerText = this.productForm.activeVariant.price;
    }

    connectedCallback() {
      if (!this.productForm) {
        this.productForm = this.closest('vbb-product-form-reactive');
        this.productForm.addEventListener('variant:changed', this.handleVariantChange);
      }
    }

    disconnectedCallback() {
      if (this.productForm) {
        this.productForm.removeEventListener('variant:changed', this.handleVariantChange);
      }
    }
  });
}
